import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const CustomSingleSelect = ({ options, selectedOption, setSelectedOption, height, disable= false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const inputRef = useRef(null);
  const portalRef = useRef(null);
  const containerRef = useRef(null);
  const [displayName, setDisplayName] = useState(selectedOption?.name) 
  const filteredOptions = options?.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setSearchTerm('');
    setDisplayName(option.name);
    setIsOpen(false);
  };

  const handleInputClick = () => {
    setIsOpen(true);
    if (selectedOption) {
      setDisplayName(selectedOption.name);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setDisplayName(e.target.value)
    setIsOpen(true);
  };

  useEffect(() => {
    if(selectedOption){
      setDisplayName(selectedOption.name)
    }
  },[selectedOption?.name])


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        portalRef.current &&
        !portalRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        setSearchTerm('')

        if(selectedOption?.name){
          setDisplayName(selectedOption?.name)
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [selectedOption]);

  const containerStyle = {
    position: 'relative',
    width: '100%',
  };

  const inputContainerStyle = {
    position: 'relative',
    border: '1px solid #EBEBEB',
    borderRadius: '4px',
    backgroundColor: disable ? '#F4F5F9': "white",
    cursor: 'text',
    display: 'flex',
    alignItems: 'center',
    height: `${height}px`,
    padding: '0 40px 0 12px',
  };

  const inputStyle = {
    border: 'none',
    outline: 'none',
    width: '100%',
    fontWeight: "400",
    fontSize: "12px",
    backgroundColor: 'transparent',
    cursor: 'inherit',
  };

  const arrowStyle = {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: `translateY(-50%) ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}`,
    transition: 'transform 0.2s ease',
    cursor: 'pointer',
  };

  const optionStyle = (isSelected) => ({
    fontWeight: "400",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: '5px 10px',
    cursor: 'pointer',
    backgroundColor: isSelected ? 'var(--NavLight)' : 'transparent',
    color: isSelected ? 'white' : '#333',
  });

  const getPlaceholder = () => {
    if (selectedOption && !isOpen) return '';
    return 'Select...';
  };

  const renderDropdown = () => {
    if (!isOpen || !inputRef.current) return null;

    const rect = inputRef.current.getBoundingClientRect();

    const dropdownStyle = {
      position: 'absolute',
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
      backgroundColor: 'white',
      border: '1px solid #EBEBEB',
      borderTop: 'none',
      borderRadius: '0 0 4px 4px',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 9999,
    };

    return ReactDOM.createPortal(
      <div ref={portalRef} style={dropdownStyle}>
        {filteredOptions.length > 0 ? (
          filteredOptions.map(option => (
            <div
              key={option.id}
              style={optionStyle(selectedOption?.id === option.id)}
              onClick={() => handleOptionClick(option)}
              onMouseEnter={(e) => {
                if (selectedOption?.id !== option.id) {
                  e.target.style.backgroundColor = '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedOption?.id !== option.id) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              {option.name}
            </div>
          ))
        ) : (
          <div style={{ padding: '5px 10px', color: '#999', fontStyle: 'italic' }}>
            No options found
          </div>
        )}
      </div>,
      document.body
    );
  };

  return (
    <div style={containerStyle} ref={containerRef}>
      <div style={{...inputContainerStyle, pointerEvents: disable ? 'none' : 'auto'}} onClick={handleInputClick} ref={inputRef}>
        <input
          style={inputStyle}
          value={displayName}
          onChange={handleInputChange}
          placeholder={getPlaceholder()}
          onFocus={() => setIsOpen(true)}
        />
        <div style={arrowStyle} onClick={() => setIsOpen(!isOpen)}>
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path
              d="M1 1L6 6L11 1"
              stroke="#9C9699"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      {renderDropdown()}
    </div>
  );
};

export default CustomSingleSelect;
